import {Contributor} from "./User";

export class Project {
    id!: number;

    title!: string;

    description?: string;

    icon?: string;

    cover?: string;

    settingId?: number;

    contributors?: Contributor[];
}

export class ConfigNarration {
    x: number = 0;

    y: number = 0;

    z: number = 0;

    height: number = 0;

    width: number = 0;

    background_url?: string;

    background_fill_type: 'Fit' | 'FillX' | 'FillY' | 'Fill' | 'Stretch' | 'Crop' = 'Stretch';

    background_nine_slice_top?: number;

    background_nine_slice_bottom?: number;

    background_nine_slice_left?: number;

    background_nine_slice_right?: number;

    avatar_x?: number;

    avatar_y?: number;

    avatar_width?: number;

    avatar_height?: number;

    name_x?: number;

    name_y?: number;

    name_font_size?: number;

    name_font_color?: string;

    name_font_style?: 'normal' | 'italic';

    name_font_weight?: 'normal' | 'bold' | 'semi-bold' | 'light' | 'thin';

    text_x?: number;

    text_y?: number;

    text_width?: number;

    text_font_size: number = 32;

    text_font_color?: string;

    text_font_style?: 'normal' | 'italic';

    text_font_weight?: 'normal' | 'bold' | 'semi-bold' | 'light' | 'thin';

    text_appearing?: 'Sentence' | 'Letter' | 'Word' | 'Paragraph' | 'All';

    orientation?: 'Landscape' | 'Portrait';
}

export class ConfigChoices {

    background_url?: string;

    background_fill_type: 'Fit' | 'FillX' | 'FillY' | 'Fill' | 'Stretch' | 'Crop' = 'Stretch';

    background_nine_slice_top?: number;

    background_nine_slice_bottom?: number;

    background_nine_slice_left?: number;

    background_nine_slice_right?: number;

    text_font_size: number = 32;

    text_font_color?: string;

    padding?: number = 10;

    text_font_style?: 'normal' | 'italic';

    text_font_weight?: 'normal' | 'bold' | 'semi-bold' | 'light' | 'thin';

    orientation?: 'Landscape' | 'Portrait';
}